// extracted by mini-css-extract-plugin
export default {"button":"sl-z","reviewSort":"tl-z"};